import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerListComponent } from './banner-list/banner-list.component';
import { BannerFormComponent } from './banner-form/banner-form.component';
import { MaterialModule } from '../material/material.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [BannerListComponent, BannerFormComponent],
  imports: [CommonModule, MaterialModule, DragDropModule],
})
export class BannerModule {}
